import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterDirectoryItem_template} from "./filterDirectoryItem_template";

declare var ko: any;

export class directoryEdit_template extends vnTemplate {

    public filterDirectoryItem: filterDirectoryItem_template;
    private modifiedNodeReference: any;
    private modifiedNodeReferenceParent: any;
    private movedNodeReference: any;
    private movedNodeIndex: number;
    private movedNodeReferenceParent: any;
    private initialDirectoryItems: any;
    private operationType: number; // 1: AddChild, 2:Edit,
    private previousOperationType: number = null; // 1: Add, 2:Edit
    private directoryItemsHistory: Array<any>;
    private deletedDirectoryItem: any;
    private deletedDirectoryItemParent: any;
    private deletedDirectoryItemIndex : number;

    protected getTemplateHtml(): string {

        return `

            <div data-bind="visible: $parent.idTemplate() == 7, class: $root['edit_template_new'][activeDirectory()].containerClassItemMove">

                <div class="w-form w-form-sub directory" data-bind="css: { 'is-showing' : isDirectoryItemAddFormShown }" xmlns="http://www.w3.org/1999/html">
                    <div class="form-header">
                        <h3 class="form-title" data-bind="text: (formVerb() + ' Item in Directory')"> </h3>
                        <button class="close-button icon i-close-2" type="button" data-bind="disable: isGlobalLockEnabled() ,event: { click: onClickCancelDirectoryItem }"></button>
                    </div>
                    <div class="w-form-body">
                        <div class="form-body full-width">
                            <div class="form-group inside-label">
                                <label for="title" class="form-label">Title</label>
                                <textarea placeholder="No section title here for now..." data-bind="value: sectionTitle" type="text" class="input-text"  data-bind="disable: $parent.isPublishingControl() || $parent.isGlobalLockEnabled() "></textarea>
                            </div>
                            <div class="form-group">
                                <label for="description" class="form-label" >Description</label>
                                <textarea data-bind="value: description, attr: {id: activeDirectory() + '_item_description'}"></textarea>
                            </div>
                            <div class="form-group">
                                ` + this.filterDirectoryItem.getHtmlBuild() + `
                             </div>
                             <div class="form-group inside-label" data-bind="visible: selectedDirectoryItemArticle() != null">
                                <label for="title" class="form-label">Alternate title</label>
                                <textarea data-bind="value: alternativeArticleTitle" type="text" class="input-text"  data-bind="disable: $parent.isPublishingControl() || $parent.isGlobalLockEnabled()"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="form-footer">
                        <button class="btn" type="button" data-bind="event: { click: onClickCancelDirectoryItem }">Cancel</button>
                        <button class="btn highlight" type="button" data-bind="event: { click: onClickSaveAndAddNext }">Apply & Add Next</button>
                        <button class="btn highlight" type="button" data-bind="event: { click: onClickSaveDirectoryItem }">Apply</button>
                    </div>
                </div>


                <div class="w-form-body directory-content">
                    <strong class="form-sub-title" >Directory</strong>
                    <div class="form-body">
                        <div class="form-group">
                            <button data-bind="event: { click: onClickAddDirectoryRootItem.bind($data) }, enable: $root['edit_template_new'][activeDirectory()].containerClassItemMove() == 'i-move-outside' && !$root['edit_template_new'][activeDirectory()].somethingSelectedForDelete()" class="btn-form icon i-plus" type="button"><span >Add root directory item</span></button>  <!--  class="hide" -->
                            <button data-bind="enable: isUndoAllChangesEnabled() && $root['edit_template_new'][activeDirectory()].containerClassItemMove() == 'i-move-outside' && !$root['edit_template_new'][activeDirectory()].somethingSelectedForDelete(), event: { click: undoAllChanges }" class="btn-form" type="button"><span>Undo all changes</span></button> <!--  class="hide" -->
                            <button data-bind="enable: isUndoLastDeleteEnabled() && $root['edit_template_new'][activeDirectory()].containerClassItemMove() == 'i-move-outside' && !$root['edit_template_new'][activeDirectory()].somethingSelectedForDelete(), event: { click: undoLastDelete }" class="btn-form" type="button"><span >Undo last delete</span></button>  <!--  class="hide" -->
                        </div>

                        <div data-bind = "visible: $root['edit_template_new'][activeDirectory()].containerClassItemMove() == 'i-target'">
                            <button class="btn-form icon i-target" type="button" data-bind="visible: $root['edit_template_new'].idStatus() != 6 || ($root['edit_template_new'].idStatus() == 6 && $root['edit_template_new'].permissions()['article_edit_publishingControl'].write), event: { click: $root['edit_template_new'][activeDirectory()].moveToRoot }"><span class="hide">Move to root</span></button>
                        </div>

                        <script id="treeElement" type="text/html">

                             <li class="list-item"  data-bind="css:{ 'selected-for-delete': selectedForDelete(), 'selected-for-move': selectedForMove() }" >
                                 <div class="inner-wrap">
                                     <div class="w-btn">

                                         <button class="btn-form icon i-move-outside" title="Move" type="button" data-bind="disable: !($root['edit_template_new'].idStatus() != 6 || ($root['edit_template_new'].idStatus() == 6 && $root['edit_template_new'].permissions()['article_edit_publishingControl'].write)) && $root['edit_template_new'][activeDirectory()].containerClassItemMove() == 'i-move-outside', event: { click: $root['edit_template_new'][activeDirectory()].moveTo.bind(null, $parent) }, enable: !$root['edit_template_new'][activeDirectory()].somethingSelectedForDelete()"><span class="hide"></span></button>
                                         <button class="btn-form icon add-as-child i-child left" title="Insert In" data-bind="click: $root['edit_template_new'][activeDirectory()].insertIn, disable: !($root['edit_template_new'][activeDirectory()].containerClassItemMove() == 'i-target') "><span class="hide">Insert In</span></button>
                                         <button class="btn-form icon place-after i-place-after right" title="Insert Next" data-bind="click: $root['edit_template_new'][activeDirectory()].insertNext.bind(null, $parent), disable: !($root['edit_template_new'][activeDirectory()].containerClassItemMove() == 'i-target') "><span class="hide">Insert Next</span></button>

                                         <span data-bind="if: !isDirectory()">
                                            <button class="btn-form icon i-add_inside" data-bind="disable: !($root['edit_template_new'].idStatus() != 6 || ($root['edit_template_new'].idStatus() == 6 && $root['edit_template_new'].permissions()['article_edit_publishingControl'].write)), event: { click: $root['edit_template_new'][activeDirectory()].onClickAddDirectoryItem.bind($data)}, enable: $root['edit_template_new'][activeDirectory()].containerClassItemMove() == 'i-move-outside' && !$root['edit_template_new'][activeDirectory()].somethingSelectedForDelete()" title="Add As Child" type="button"><span class="hide">Add Inside</span></button>
                                         </span>

                                        <button class="btn-form icon i-edit" type="button" title="Edit" data-bind="disable: !($root['edit_template_new'].idStatus() != 6 || ($root['edit_template_new'].idStatus() == 6 && $root['edit_template_new'].permissions()['article_edit_publishingControl'].write)), event: { click: $root['edit_template_new'][activeDirectory()].onClickEditDirectoryItem.bind($data, $parent) }, enable: $root['edit_template_new'][activeDirectory()].containerClassItemMove() == 'i-move-outside' && !$root['edit_template_new'][activeDirectory()].somethingSelectedForDelete()"><span class="hide">Edit</span></button>
                                        <button class="btn-form icon highlight i-delete" title="Delete" type="button" data-bind="disable: !($root['edit_template_new'].idStatus() != 6 || ($root['edit_template_new'].idStatus() == 6 && $root['edit_template_new'].permissions()['article_edit_publishingControl'].write)), event: { click: $root['edit_template_new'][activeDirectory()].onClickDeleteDirectoryItem.bind($data, $parent) }, enable: $root['edit_template_new'][activeDirectory()].containerClassItemMove() == 'i-move-outside' && !$root['edit_template_new'][activeDirectory()].somethingSelectedForDelete()"><span class="hide">Delete</span></button>

                                     </div>

                                     <div>
                                         <strong class="item-title" data-bind="text: sectionTitle"></strong>
                                         <div class="item-description" data-bind="html: $data.description"></div>
                                         <span data-bind="with: item">
                                               <span data-bind="if: $parent.alternativeArticleTitle">
                                                      <a class="item-link" data-bind="text: $parent.alternativeArticleTitle, attr: { href: 'https://'+$root['edit_template_new']['brand']()['domain']+'/'+permalink }" target="_blank"  ></a>
                                               </span>
                                               <span data-bind="ifnot: $parent.alternativeArticleTitle">
                                                      <a class="item-link" data-bind="text: title, attr: { href: 'https://'+$root['edit_template_new']['brand']()['domain']+'/'+permalink }" target="_blank"  ></a>
                                               </span>
                                         </span>
                                     </div>
                                 </div>

                                 <ul class="list" data-bind="template: { name: 'treeElement', foreach: $data.directoryItems }"> </ul>

                                 <div class="form-footer "  data-bind = "">
                                    <button type="button" data-bind="event: { click: $root['edit_template_new'][activeDirectory()].onClickCancelDirectoryItemDelete }, visible: $root['edit_template_new'][activeDirectory()].containerClassItemMove() == 'i-move-outside'" class="btn ">Cancel</button>
                                    <button type="button" data-bind="click: $root['edit_template_new'][activeDirectory()].onClickConfirmDirectoryItemDelete, visible: $root['edit_template_new'][activeDirectory()].containerClassItemMove() == 'i-move-outside'" class="btn highlight">Delete</button>
                                 </div>
                                 <div class=" form-footer " data-bind = "visible: $root['edit_template_new'][activeDirectory()].containerClassItemMove() == 'i-target'">
                                    <button class="close-button icon i-close-2" type="button" data-bind="visible: $root['edit_template_new'].idStatus() != 6 || ($root['edit_template_new'].idStatus() == 6 && $root['edit_template_new'].permissions()['article_edit_publishingControl'].write), event: { click: $root['edit_template_new'][activeDirectory()].onClickCancelMove }"><span class="hide">Cancel move</span></button>
                                 </div>

                            </li>
                        </script>

                        <div class="form-group">
                            <ul class="list" data-bind="template: { name: 'treeElement', foreach: directoryItems } " ></ul>
                        </div>
                     </div>

                </div>

           </div>

           <div data-bind="css: { 'is-visible': isRevertAllChangesVisible }" class="w-lightbox light-theme">
              <div class="lightbox-content">
                  <div class="w-form lightbox-form">
                      <div class="form-header">
                          <h3 class="form-title">Revert all changes</h3>
                      </div>
                      <div class="form-body">
                          <div class="form-group">
                              <p class="form-text">Are you sure you want to DELETE EVERY CHANGE made since last save? There is no coming back.</p>
                          </div>
                       </div>
                      <div class="form-footer">
                          <button type="button" data-bind="event: { click: onClickConfirmRevertChanges}" class="btn highlight">Confirm</button>
                          <button type="button" data-bind="event: { click: onClickCancelRevertChanges}" class="btn ">Cancel</button>
                      </div>

                  </div>
              </div>
           </div>
        `;
    }

    public buildViewModel() {

        let that = this;

        return {

             activeDirectory: ko.observable("article_directory")
            ,directoryItems: ko.observableArray([])
            ,destroyedDirectoryItem: ko.observableArray([])
            ,deletedDirectoryItems: ko.observableArray([])
            ,selectedDirectoryItemId: ko.observable()
            ,somethingSelectedForDelete: ko.observable(false)
            ,selectedDirectoryItemArticleTitle: ko.observable()
            ,selectedDirectoryItemIdArticle: ko.observable()
            ,formVerb: ko.observable("")
            ,containerClassItemMove: ko.observable("i-move-outside")
            ,selectedDirectoryItemArticle: ko.observable(null)
            ,selectedDirectoryItemIdParent: ko.observable()
            ,selectedDirectoryItemPosition: ko.observable()
            ,selectedDirectoryItemDateCreated: ko.observable()
            ,isDirectoryItemAddFormShown: ko.observable(false)
            ,isDirectoryItemDeleteVisible: ko.observable(false)
            ,isRevertAllChangesVisible: ko.observable(false)
            ,isUndoLastDeleteEnabled: ko.observable(false)
            ,isUndoAllChangesEnabled: ko.observable(false)
            ,alternativeArticleTitle: ko.observable("")
            ,sectionTitle: ko.observable("")
            ,description: ko.observable("")
            ,addNextChild: ko.observable(false)
            ,isShowArticleSuggestions: ko.observable(false)
            ,isPublishingControl : ko.observable(false)
            ,isGlobalLockEnabled : ko.observable(false)
            ,onClickCancelDirectoryItem: function(data, event){ that.onClickCancelDirectoryItem();}
            ,onClickAddDirectoryItem: function(value, data, event){that.onClickAddDirectoryItem(value);}
            ,onClickAddDirectoryRootItem: function(value,data,event){that.onClickAddDirectoryRootItem(value);}
            ,onClickDeleteDirectoryItem: function(value, value1, data, event){that.onClickDeleteDirectoryItem(value, value1);}
            ,onClickEditDirectoryItem: function(parent, data){that.onClickEditDirectoryItem(parent, data);}
            ,onClickSaveDirectoryItem: function(data, event){that.onClickSaveDirectoryItem();}
            ,onClickSaveAndAddNext: function(data, event){that.onClickSaveAndAddNext(data);}
            ,onClickConfirmDirectoryItemDelete: function (value, data, event) {that.onClickConfirmDirectoryItemDelete();}
            ,onClickCancelDirectoryItemDelete: function (value, data, event) {that.onClickCancelDirectoryItemDelete();}
            ,onClickConfirmRevertChanges: function (value, data, event) {that.onClickConfirmRevertChanges();}
            ,onClickCancelRevertChanges: function (value, data, event) {that.onClickCancelRevertChanges();}
            ,undoLastDelete: function (value, data, event) {that.onClickUndoLastDelete();}
            ,undoAllChanges: function (value, data, event) {that.undoAllChanges();}
            ,moveTo: function(data, parent  ){ that.moveTo(data, parent); }
            ,insertNext: function(data, parent  ){ that.insertNext(data, parent); }
            ,moveToRoot: function( ){ that.moveToRoot(); }
            ,insertIn: function(data, event){that.insertIn(data);}
            ,onClickCancelMove: function( ){ that.onClickCancelMove(); }
        };
    }

    public getId(){

        return this.getTemplateViewModel().activeDirectory();
    }

    public setId(id){

        return this.getTemplateViewModel().activeDirectory(id);
    }

    public getDirectoryItems(){

        return this.getTemplateViewModel().directoryItems();
    }

    public setDirectoryItems(directoryItems){

        return this.getTemplateViewModel().directoryItems(directoryItems);
    }

    public getDeletedDirectoryItems(){

        this.getTemplateViewModel().deletedDirectoryItems();
    }

    public setDeletedDirectoryItems(deletedDirectoryItems){

        this.getTemplateViewModel().deletedDirectoryItems(deletedDirectoryItems);
    }

    private resetMove() {

        this.getTemplateViewModel().containerClassItemMove("i-move-outside");
        this.movedNodeReference.selectedForMove(false);
        this.movedNodeReference = null;
    }

    private onClickCancelMove() {

        this.resetMove();

    }

    private moveToRoot() {
        this.spliceMovedItem();
        let dirItems = this.getTemplateViewModel().directoryItems();

        this.movedNodeReference.position(dirItems.length+1)

        this.movedNodeReference.idParent(null)

        dirItems.splice(0, 0, this.movedNodeReference);

        for(let i = 0; i < dirItems.length; i++ ) {
            dirItems[i].position(i+1);
        }

        this.getTemplateViewModel().directoryItems([]);
        this.getTemplateViewModel().directoryItems(dirItems);
        this.getTemplateViewModel().isUndoAllChangesEnabled(true);
        this.resetMove();
    }

    private moveTo(parent, data) {

        data.selectedForMove(true);
        this.movedNodeIndex = data.position() - 1;
        this.movedNodeReference = data;
        this.movedNodeReferenceParent = parent;
        this.getTemplateViewModel().containerClassItemMove("i-target")

    }
    private onClickUndoLastDelete(){
        this.spliceLastDeleted(true);
        //this.getTemplateViewModel().isUndoLastDeleteEnabled(false);
    }
    private spliceMovedItem() {
        let arrayWithRemovedElem = this.movedNodeReferenceParent.directoryItems();

        //arrayWithRemovedElem.splice( this.movedNodeReference.position() - 1 , 1);

        let elemIndex = 0;

        arrayWithRemovedElem.forEach((elem, index) => {
            if(elem === this.movedNodeReference){
                elemIndex = index;
            }
        });

        arrayWithRemovedElem.splice(elemIndex , 1);


        for(let i = this.movedNodeIndex; i < arrayWithRemovedElem.length; i++ ) {
            arrayWithRemovedElem[i].position(i+1);
        }

        arrayWithRemovedElem.forEach( e => {console.log(e.position())});
        this.movedNodeReferenceParent.directoryItems(arrayWithRemovedElem);
    }

    private insertIn(data) {
        let arrayWithAddedNode = data.directoryItems();
        this.spliceMovedItem()
        this.movedNodeReference.idParent( data.id() );
        this.movedNodeReference.position(1)


        this.movedNodeReference.level(data.level()+1)
        arrayWithAddedNode.splice(0, 0, this.movedNodeReference);
       // arrayWithAddedNode.forEach( e => {console.log(e.position())});

        for(let i = 0; i < arrayWithAddedNode.length; i++ ) {
            arrayWithAddedNode[i].position(i+1);
        }
        data.directoryItems(arrayWithAddedNode)
        this.getTemplateViewModel().isUndoAllChangesEnabled(true);
        this.resetMove();
    }

    private insertNext(parent, data) {
        let arrayWithAddedNode = parent.directoryItems();
        this.movedNodeReference.idParent(null);
        this.spliceMovedItem();
        this.movedNodeReference.position(data.position()+1)
        this.movedNodeReference.level(data.level())

        arrayWithAddedNode.splice(data.position(),0, this.movedNodeReference);

        for(let i = 0; i < arrayWithAddedNode.length; i++ ) {
            arrayWithAddedNode[i].position(i+1);
        }
        arrayWithAddedNode.forEach( e => {console.log(e.position())});

        parent.directoryItems(arrayWithAddedNode)
        this.getTemplateViewModel().isUndoAllChangesEnabled(true);
        this.resetMove();
    }

    private undoAllChanges(){

        this.getTemplateViewModel().isRevertAllChangesVisible(true);
    }

    private onClickCancelRevertChanges() {

        this.getTemplateViewModel().isRevertAllChangesVisible(false);

    }

    protected onClickConfirmRevertChanges(){

        if(this.getTemplateViewModel().activeDirectory() == 'sandbox_directory'){
            this.setSandboxDirectoryItems(this.initialDirectoryItems)
        }else{
            this.setDirectoryItemsObservable(this.initialDirectoryItems)
        }
        this.getTemplateViewModel().isUndoAllChangesEnabled(false);
        this.getTemplateViewModel().isUndoLastDeleteEnabled(false);
        this.getTemplateViewModel().isRevertAllChangesVisible(false);
        this.getTemplateViewModel().deletedDirectoryItems.removeAll();

    }

    protected onClickConfirmDirectoryItemDelete(){
        this.spliceLastDeleted(false);
        this.deletedDirectoryItem.selectedForDelete(false)

        this.getTemplateViewModel().somethingSelectedForDelete(false);
    }

    private spliceLastDeleted(undo = false){

        let directoryItems  = this.deletedDirectoryItemParent.directoryItems();;

        if ( undo )
            directoryItems.splice(this.deletedDirectoryItemIndex,0, this.deletedDirectoryItem);
        else{
            directoryItems.splice(this.deletedDirectoryItemIndex, 1);
        }

        for (let i= 0; i < directoryItems.length; i++ ) {
            directoryItems[i].position(i+1)
            //console.log(  directoryItems[i].position() )
        }

        this.deletedDirectoryItemParent.directoryItems( directoryItems );

        if (undo) {
            this.getTemplateViewModel().deletedDirectoryItems.pop();
            this.getTemplateViewModel().isUndoLastDeleteEnabled(false);
        }
        else {
            this.getTemplateViewModel().deletedDirectoryItems.push(this.deletedDirectoryItem);
            this.getTemplateViewModel().isDirectoryItemDeleteVisible(false);
            this.getTemplateViewModel().isUndoLastDeleteEnabled(true);
            this.getTemplateViewModel().isUndoAllChangesEnabled(true);
        }

        this.getTemplateViewModel().destroyedDirectoryItem([])

    }

    protected onClickCancelDirectoryItemDelete() {

        this.deletedDirectoryItem.selectedForDelete( false );
        this.getTemplateViewModel().isDirectoryItemDeleteVisible(false);
        this.getTemplateViewModel().somethingSelectedForDelete(false);
        //this.getTemplateViewModel().destroyedDirectoryItem([])
    }

    protected onClickDeleteDirectoryItem(parent, data){
        // if (this.deletedDirectoryItem){
        //     this.deletedDirectoryItem.selectedForDelete( false );
        // }
        this.deletedDirectoryItem = data;

        console.log(this.deletedDirectoryItem.alternativeArticleTitle())
        this.deletedDirectoryItem.selectedForDelete( true );
        this.deletedDirectoryItemParent = parent;
        this.deletedDirectoryItemIndex = data.position()-1;
        this.getTemplateViewModel().isDirectoryItemDeleteVisible(true);
        this.getTemplateViewModel().somethingSelectedForDelete(true);


    }

    protected initPartial(): void {
        this.filterDirectoryItem = new filterDirectoryItem_template("filterDirectoryItem", this.getTemplateViewModel(), this.caller);
        this.getTemplateViewModel().filterDirectoryItem.showDetails(true);
    }

    protected onClickCancelDirectoryItem(){

        this.clearDirectoryItemForm();
        this.getTemplateViewModel().isDirectoryItemAddFormShown(false);
    }

    protected onClickSaveAndAddNext(parent){
        this.onClickSaveDirectoryItem(true);
    }

    protected onClickSaveDirectoryItem( addNext = false ){

        let id = this.getTemplateViewModel().activeDirectory();
        this.caller.validateDirectoryItem(addNext, id);

    }


    protected addNextAfterAddChild(directoryItem)
    {
        let level = this.modifiedNodeReference.hasOwnProperty('level')  ? this.modifiedNodeReference.level() + 1  :  1;
        let directoryItems = this.modifiedNodeReference.directoryItems();
        directoryItem.level = ko.observable(level);
        directoryItem().position(directoryItems.length+1);
        directoryItems.push(directoryItem());
        this.modifiedNodeReference.directoryItems(directoryItems);
    }

    protected addNextAfterEdit(directoryItem)
    {
        let parent = this.modifiedNodeReferenceParent ? this.modifiedNodeReferenceParent : this.getTemplateViewModel();
        let level = 1;
        if(this.modifiedNodeReferenceParent){
            level = this.modifiedNodeReferenceParent.hasOwnProperty('level')  ? this.modifiedNodeReferenceParent.level()  : 1;
        }
        let directoryItems = parent.directoryItems();
        directoryItem.level = ko.observable(level);
        directoryItem().position(directoryItems.length+1);
        directoryItems.push(directoryItem());
        parent.directoryItems(directoryItems);
    }

    protected addDirectoryItem(  addNext = false, selectedTab) {

        let directoryItems = this.getTemplateViewModel().directoryItems();

        let description = this.caller.getDirectoryItemCkEditorData();
        this.getTemplateViewModel().description(description);

        let alternativeArticleTitle = this.getTemplateViewModel().alternativeArticleTitle();
        let idParent = this.getTemplateViewModel().selectedDirectoryItemIdParent();
        let selectedDirectoryItemArticle = this.getTemplateViewModel().selectedDirectoryItemArticle();
        let sectionTitle = this.getTemplateViewModel().sectionTitle();

        if (selectedDirectoryItemArticle == null) {
            this.filterDirectoryItem.resetArticle();
            this.getTemplateViewModel().alternativeArticleTitle(null);
        }

        let selectedDirectoryItemPosition = this.getTemplateViewModel().selectedDirectoryItemPosition();
        let selectedDirectoryItemDateCreated = this.getTemplateViewModel().selectedDirectoryItemDateCreated();
        let selectedDirectoryItemId = this.getTemplateViewModel().selectedDirectoryItemId();
        let position = 0;
        if (this.operationType == 1  ) //1 = Add
        {

            let directoryItems;
            let directoryItem = ko.observable({
                id: ko.observable(selectedDirectoryItemId),
                directoryItems: ko.observableArray([]),
                dateCreated: selectedDirectoryItemDateCreated,
                description: ko.observable(description),
                idParent: ko.observable(idParent),
                item: ko.observable(selectedDirectoryItemArticle),
                level: ko.observable(0),
                position: ko.observable(selectedDirectoryItemPosition),
                alternativeArticleTitle: ko.observable(alternativeArticleTitle),
                sectionTitle: ko.observable(sectionTitle),
                selectedForDelete:  ko.observable(false),
                selectedForMove:  ko.observable(false),
                activeDirectory: ko.observable(this.getTemplateViewModel().activeDirectory()),
                isDirectory: ko.observable(selectedDirectoryItemArticle && selectedDirectoryItemArticle.idTemplate == "7")
            });
            //1 = add , 2 = edit
            if(this.getTemplateViewModel().addNextChild()){

                this.addNextAfterAddChild(directoryItem);
                this.modifiedNodeReferenceParent = this.modifiedNodeReference ;
                this.getTemplateViewModel().addNextChild(false);
            }
            else{
                this.addNextAfterEdit(directoryItem);
            }
            // if ( this.previousOperationType == 1 || this.previousOperationType == null ) //Add
            // {
            // }
            // else if ( this.previousOperationType == 1) //Edit
            // {
                //Add next after add next after edit
            // }

        }

        else if (this.operationType == 2){ //Edit
            this.modifiedNodeReference.alternativeArticleTitle(alternativeArticleTitle);
            this.modifiedNodeReference.description(description);
            this.modifiedNodeReference.sectionTitle(sectionTitle);
            this.modifiedNodeReference.item(selectedDirectoryItemArticle);
            this.modifiedNodeReference.isDirectory( selectedDirectoryItemArticle && selectedDirectoryItemArticle.idTemplate == "7");
            this.previousOperationType = this.operationType;
        }


        this.clearDirectoryItemForm();
        this.getTemplateViewModel().isUndoAllChangesEnabled(true);

        //console.log(this.previousOperationType, this.operationType)

        this.previousOperationType = this.operationType;


        if (addNext){
            this.operationType = 1;
            this.clearDirectoryItemForm();
            this.getTemplateViewModel().formVerb("Add new");
        }
        else
        {
            this.previousOperationType = this.operationType;
            this.getTemplateViewModel().isDirectoryItemAddFormShown(false);
            //this.operationType = 1;
        }

        this.caller.save_recovery('applyDirectoryItem')

    }

    protected clearDirectoryItemForm(){

        this.caller.clearValidationErrors();
        this.filterDirectoryItem.onClearInput(null);

        this.caller.setDirectoryItemCkEditorData("");
        this.getTemplateViewModel().sectionTitle("");
        this.getTemplateViewModel().alternativeArticleTitle("");
        this.getTemplateViewModel().description("");
        this.getTemplateViewModel().selectedDirectoryItemId(null);
        this.getTemplateViewModel().selectedDirectoryItemPosition(null);
        this.getTemplateViewModel().selectedDirectoryItemDateCreated(null);
        this.getTemplateViewModel().selectedDirectoryItemArticleTitle("");
        this.getTemplateViewModel().selectedDirectoryItemIdArticle(null);
        this.getTemplateViewModel().selectedDirectoryItemIdParent(null);
        this.getTemplateViewModel().selectedDirectoryItemId(null);
        this.getTemplateViewModel().isShowArticleSuggestions(false);
        this.filterDirectoryItem.resetArticle();

    }

    protected onClickEditDirectoryItem(parent, data ){

        this.getTemplateViewModel().formVerb("Edit existing");
        this.operationType = 2;
        this.modifiedNodeReference = data;
        this.modifiedNodeReferenceParent = parent;
        console.log(data.sectionTitle(), parent.sectionTitle())

        if(data) {

            this.getTemplateViewModel().alternativeArticleTitle(data.alternativeArticleTitle());
            this.getTemplateViewModel().description(data.description());
            this.getTemplateViewModel().sectionTitle(data.sectionTitle());
            this.getTemplateViewModel().selectedDirectoryItemId(data.id());
            this.getTemplateViewModel().selectedDirectoryItemPosition(data.position());
            this.getTemplateViewModel().selectedDirectoryItemDateCreated(data.dateCreated)
            this.getTemplateViewModel().selectedDirectoryItemIdParent(data.idParent());

            if (data.item())
            {

                this.getTemplateViewModel().selectedDirectoryItemArticle(data.item());
                this.getTemplateViewModel().selectedDirectoryItemIdArticle(data.item().id);
                this.getTemplateViewModel().selectedDirectoryItemArticleTitle(data.item().title);
                let closeBtn = document.querySelector("#directoryFilter [id^='user-input-close_']")
                closeBtn.classList.add('is-showing');
            }
            else
            {
                this.resetSelectedArticle();
            }
            this.caller.setDirectoryItemCkEditorData(data.description);
            this.getTemplateViewModel().isDirectoryItemAddFormShown(true);
        }
    }

    public resetSelectedArticle() {

        this.getTemplateViewModel().selectedDirectoryItemArticle(null);
        this.getTemplateViewModel().selectedDirectoryItemIdArticle(null);
        this.getTemplateViewModel().selectedDirectoryItemArticleTitle("");
        this.getTemplateViewModel().alternativeArticleTitle("");
    }

    protected onClickAddDirectoryItem( parentNode){

        this.modifiedNodeReference = parentNode;
        this.operationType = 1;
        this.getTemplateViewModel().addNextChild(true);
        this.clearDirectoryItemForm();
        this.getTemplateViewModel().formVerb("Add new");
        this.getTemplateViewModel().isDirectoryItemAddFormShown(true);

    }
    protected onClickAddDirectoryRootItem(parentNode){
        this.modifiedNodeReference = parentNode;
        this.modifiedNodeReferenceParent = null;
        this.operationType = 1;
        this.clearDirectoryItemForm();
        this.getTemplateViewModel().formVerb("Add new");
        this.getTemplateViewModel().isDirectoryItemAddFormShown(true);
    }

    public setDirectoryItemsObservable(directoryItems) {

        this.initialDirectoryItems = JSON.parse(JSON.stringify(directoryItems)); //faster that lodash/cloneDeep but may break depending on values
        let observableDirItems = this.makeDirectoryItemsObservable(directoryItems)
        this.getTemplateViewModel().directoryItems( observableDirItems() );
    }

    private makeDirectoryItemsObservable(directoryItems) {

        let observableDirItems = ko.observableArray([]);
        let item;
        let rootNodesAmnt = directoryItems.length;
        let levelChangePosition = rootNodesAmnt-1;
        let articleId = this.caller.articlesEdit.getId();
        let i = 0;
        let level = 1;
        let activeDirectory = this.getTemplateViewModel().activeDirectory();

        while (typeof directoryItems[i] != 'undefined')
        {

            directoryItems[i].isDirectory = false;
            while ( directoryItems[i].directoryItems && directoryItems[i].directoryItems.length != 0) {
                if (directoryItems[i].directoryItems[0].idArticle != articleId) {
                    directoryItems[i].directoryItems = {}
                    directoryItems[i].isDirectory = true;
                    break;//Keeping only directoryItems that are in the same article, not the onces that are directoryItems of other directory articles
                }
                directoryItems.push(directoryItems[i].directoryItems.pop());
            }
            //Making EVERYTHING observable
            directoryItems[i] = ko.observable(directoryItems[i]);
            directoryItems[i]().directoryItems = ko.observableArray([]);//along with their future directoryItems
            directoryItems[i]().description = ko.observable(directoryItems[i]().description)
            directoryItems[i]().id = ko.observable(directoryItems[i]().id)
            directoryItems[i]().isDirectory = ko.observable(directoryItems[i]().isDirectory)
            directoryItems[i]().idParent = ko.observable(directoryItems[i]().idParent)
            directoryItems[i]().item = ko.observable(directoryItems[i]().item)
            directoryItems[i]().position = ko.observable(directoryItems[i]().position)
            directoryItems[i]().alternativeArticleTitle = ko.observable(directoryItems[i]().alternativeArticleTitle)
            directoryItems[i]().sectionTitle = ko.observable(directoryItems[i]().sectionTitle)
            directoryItems[i]().selectedForDelete = ko.observable(false)
            directoryItems[i]().selectedForMove = ko.observable(false)
            directoryItems[i]().level = ko.observable(level)
            directoryItems[i]().activeDirectory = ko.observable(activeDirectory)
            observableDirItems.push(directoryItems[i]());
            i++;

            //console.log(i)

            if ( i == levelChangePosition)
            {
                //console.log('changing level')
                levelChangePosition = directoryItems.length;
                level++;
            }
        }

        //Rebuilding the tree
        let  l;

        while ( observableDirItems().length != rootNodesAmnt )
        {

            l = observableDirItems().length-1;
            i = observableDirItems().length-2;

            while (observableDirItems()[i].id() != observableDirItems()[l].idParent() ) {
                i--;
            }

            item = observableDirItems().pop();
            observableDirItems()[i].directoryItems.push( item );

        }

        return observableDirItems;
    }

    public setSandboxDirectoryItems(directoryItems){

        this.initialDirectoryItems = JSON.parse(JSON.stringify(directoryItems));
        let observableDirItems = ko.observableArray([]);

        for (let i = 0; i < directoryItems.length; i++) {

            let observableDirItem = this.makeDirectoryItemsObservableRecursive(directoryItems[i]);
            observableDirItems.push(observableDirItem())
        }

        this.getTemplateViewModel().directoryItems(observableDirItems());
    }

    private makeDirectoryItemsObservableRecursive(directoryItem){

        //Making EVERYTHING observable
        let items = directoryItem.directoryItems;

        directoryItem = ko.observable(directoryItem);
        directoryItem().directoryItems = ko.observableArray([]);
        if(items.length > 0){
            items.forEach(item => directoryItem().directoryItems().push(item));
        }
        directoryItem().description = ko.observable(directoryItem().description)
        directoryItem().id = ko.observable(directoryItem().id)
        directoryItem().isDirectory = ko.observable(false)
        directoryItem().idParent = ko.observable(directoryItem().idParent)
        directoryItem().item = ko.observable(directoryItem().item)
        directoryItem().position = ko.observable(directoryItem().position)
        directoryItem().alternativeArticleTitle = ko.observable(directoryItem().alternativeArticleTitle)
        directoryItem().sectionTitle = ko.observable(directoryItem().sectionTitle)
        directoryItem().selectedForDelete = ko.observable(false)
        directoryItem().selectedForMove = ko.observable(false)
        directoryItem().level = ko.observable(directoryItem().level)
        directoryItem().activeDirectory = ko.observable(this.getTemplateViewModel().activeDirectory())

        if (directoryItem().directoryItems().length > 0) {

            for (let i = 0; i < directoryItem().directoryItems().length; i++) {

                this.makeDirectoryItemsObservableRecursive(directoryItem().directoryItems()[i])
            }
        }

        return directoryItem;
    }

    public getHtmlBuild(): string {
        let div = document.createElement('div');
        div.appendChild( this.build() );
        return div.innerHTML;
    }

    protected getTemplateName(): string {
        return "directoryEdit_template2";
    }


    public setIsPublishingControl(value : boolean){
        this.getTemplateViewModel().isPublishingControl(value)
    }

    public setIsGlobalLockEnabled(value : boolean){
        this.getTemplateViewModel().isGlobalLockEnabled(value)
    }

}


// WEBPACK FOOTER //
// ./js/components/templates/directoryEdit_template.ts